import { apiFormRequest, apiRequest, buildQuery } from "@/apis/client";
import type {
  Organization,
  OrganizationListResponse,
  OrganizationPayload,
  OrganizationUploadLogoResponse,
} from "@/apis/types";

export interface ListOrganizationsParams {
  page?: number;
  limit?: number;
}

export const organizationsApi = {
  list(params: ListOrganizationsParams = {}): Promise<OrganizationListResponse> {
    const query = buildQuery({
      page: params.page,
      limit: params.limit ?? 500,
    });
    return apiRequest<OrganizationListResponse>(`/admin/organizations${query}`);
  },

  create(payload: OrganizationPayload): Promise<Organization> {
    return apiRequest<Organization>("/admin/organizations", "POST", payload);
  },

  update(organizationId: string, payload: OrganizationPayload): Promise<Organization> {
    return apiRequest<Organization>(
      `/admin/organizations/${organizationId}`,
      "PUT",
      payload
    );
  },

  remove(organizationId: string): Promise<void> {
    return apiRequest<void>(`/admin/organizations/${organizationId}`, "DELETE");
  },

  uploadLogo(file: File): Promise<OrganizationUploadLogoResponse> {
    const formData = new FormData();
    formData.append("file", file);
    return apiFormRequest<OrganizationUploadLogoResponse>(
      "/admin/organizations/upload-logo",
      formData,
      "POST"
    );
  },
};
